import { tw } from "@careinfo/tailwind";
import { useSearchParams } from "react-router-dom";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import BalanceSheetTable from "../Reusable/BalanceSheetTable";

export default () => {
  const { data: balanceSheetData, isLoading } = useGetHook({
    queryKey: ["application-of-fund"],
    url: APIS.BALANCE_SHEET,
    params: {},
  });

  return (
    <div className={tw`space-y-4`}>
      <BalanceSheetTable
        balanceSheetData={balanceSheetData}
        isLoading={isLoading}
      />
    </div>
  );
};
